import * as React from "react"
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from "react-native-svg"

const MB_SVG_Calendar = React.memo((props: {
    /**
     * The size of the component.
     */
    size?: number,

    /**
     * The color of the component.
     */
    color?: string,

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={props.size}
                height={props.size}
                viewBox="0 0 20 20"
                fill="none"
            >
                <Path
                    d="M15.833 3.334H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V5.001c0-.92-.746-1.667-1.667-1.667zM13.336 1.666v3.333M6.664 1.666v3.333M2.5 8.334h15"
                    stroke={props.color ?? "#ffffff"}
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </Svg>
        </View>
    )
});

export { MB_SVG_Calendar }
